import { type AxisScale, LineSeries as VisxLineSeries } from '@visx/xychart';

import type { BaseAreaSeriesProps } from '@visx/xychart/lib/components/series/private/BaseAreaSeries';

export const LineSeries = <XScale extends AxisScale, YScale extends AxisScale, Datum extends object>({
  color,
  data,
  dataKey,
  xAccessor,
  yAccessor,
  variant,
  'data-testid': dataTestId,
}: Pick<BaseAreaSeriesProps<XScale, YScale, Datum>, 'data' | 'dataKey' | 'xAccessor' | 'yAccessor'> & {
  color?: string;
  variant: 'dashed' | 'solid';
  'data-testid'?: string;
}) => {
  const variantProps = variant === 'dashed' ? { strokeDasharray: '4 4' } : {};
  return (
    <VisxLineSeries
      data={data}
      dataKey={dataKey}
      xAccessor={xAccessor}
      yAccessor={yAccessor}
      stroke={color}
      data-testid={dataTestId}
      {...variantProps}
    />
  );
};
